import React from "react";
import { Modal } from "antd";
import { ModalProps } from "antd/es/modal";
import WebCamBody from "./components/WebCamBody";

interface WebCamModalProps extends Omit<ModalProps, "onOk"> {
    onOk: (file: File) => Promise<void>;
}

export default function WebCamModal({ onOk, ...modalProps }: WebCamModalProps) {
    return (
        <Modal
            title="人脸采集"
            footer={null}
            maskClosable={false}
            destroyOnClose
            {...modalProps}>
            <WebCamBody onOk={onOk} />
        </Modal>
    );
}
